import "./SearchButton.scss";
import { useContext } from "react";
import { DarkModeContext } from "../../context/darkModeContext";

const SearchButton = ({
    searchInputRef,
    searchTerm,
    onSearch = () => { },
    onClose = () => { },
    onChange = () => { },
    searchIdItem = 0,
    searchDescItem,
    setIsModalOpen = () => { },
    handleClear = () => { },
    name,
    tipo,
    selectRef,
    searchOption,
    handleOptionChange,
    handleClearOption,
    defaultOption = "Seleccione una opción",
    options = [],
}) => {
    const { darkMode } = useContext(DarkModeContext);
    const wrapperClass = `inputWrapper ${darkMode ? "dark" : ""}`;

    if (tipo === 0) {
        return (
            <div className={wrapperClass}>
                <input
                    type="text"
                    placeholder="Buscar Descripción"
                    ref={searchInputRef}
                    value={searchTerm}
                    onChange={(e) => onChange(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            onSearch();
                        }
                    }}
                />
                {!searchTerm ? (
                    <button className="SearchButton" onClick={onSearch}>
                        🔍
                    </button>
                ) : (
                    <button className="clearButton" onClick={onClose}>
                        ❌
                    </button>
                )}
            </div>
        );
    }

    if (tipo === 1) {
        return (
            <div className={wrapperClass}>
                <input
                    type="text"
                    placeholder="Buscar Descripción"
                    value={searchDescItem || `Buscar ${name}`}
                    readOnly
                />
                {!searchDescItem ? (
                    <button
                        className="SearchButton"
                        onClick={(e) => {
                            e.preventDefault();
                            setIsModalOpen(true);
                        }}
                    >
                        🔍
                    </button>
                ) : (
                    <button
                        className="clearButton"
                        onClick={(e) => {
                            e.preventDefault();
                            handleClear();
                        }}
                    >
                        ❌
                    </button>
                )}
            </div>
        );
    }

    if (tipo === 2) {
        const defaultOptions = [
            { value: '0', label: 'No' },
            { value: '1', label: 'Sí' },
        ];
        const selectOptions = options.length > 0 ? options : defaultOptions;

        return (
            <div className={wrapperClass}>
                <select
                    className="styledSelect"
                    value={searchOption}
                    ref={selectRef}
                    onChange={handleOptionChange}
                >
                    <option value="" >
                        {`${defaultOption || 'una opción'}...`}
                    </option>
                    {selectOptions.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
                </select>

                {searchOption && (
                    <button className="clearButton" onClick={handleClearOption}>
                        ❌
                    </button>
                )}
            </div>
        );
    }

    if (tipo === 3) {
        return (
            <div className={wrapperClass}>
                <input
                    type="number"
                    placeholder="Buscar Código"
                    ref={searchInputRef}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            onSearch();
                        }
                    }}
                />
                {!searchTerm ? (
                    <button className="SearchButton" onClick={onSearch}>
                        🔍
                    </button>
                ) : (
                    <button className="clearButton" onClick={onClose}>
                        ❌
                    </button>
                )}
            </div>
        );
    }

    return <div className={wrapperClass}>Tipo no válido</div>;
};

export default SearchButton;
